import midi from "../../services/midi/MidiService";
import {useEffect} from "react";
import {displayErrorToUser} from "../../services/error/error";
import {logger} from "../../services/log/logger";

/**
 * Responsibility: Relay MIDI input connection details to Redux.
 *
 * Other components which need information about the MIDI connection should depend on the Redux store.
 *
 * Eventually this component should use its own store, instead of incorrectly depending on the settings store.
 * The settings page should depend on the Redux store that the MIDI connection uses, not the other way around.
 */
export function MIDIConnection() {
  // This useEffect doesn't need to be here. It can be replaced by putting its body in the constructor of the midiService.
  useEffect(() => {
    const maximumAttempts = 5;
    let triedAttempts = 0;
    // Try to get MIDI access 5x over 5 seconds, then display an error if it fails.
    function tryToGetMidiAccess() {
      // We don't `catch`, because we want to see ALL errors in Sentry logs, not just the last one, in case of multiple different types of failures.
      midi.requestMidiAccess().finally(() => {
        triedAttempts++;

        if (midi.hasMidiAccess()) {
          return;
        }

        if (triedAttempts < maximumAttempts) {
          logger.midiAccess.error({message: "MIDI is inaccessible."});
          setTimeout(tryToGetMidiAccess, 1000); // Recursive
        } else {
          displayErrorToUser('We could not access MIDI devices. You may continue using the app, but any keyboards you connect will not work.');
          throw new Error(`MIDI access failed after ${maximumAttempts} attempts.`);
        }
      });
    }

    tryToGetMidiAccess();
  }, []);

  // Don't render anything. This component is only for side effects.
  return null;
}
